<template>
  <div>
    <h3 class="mb-5">Main Messaging</h3>
    <div class="h4 mb-5">顯示於Career Page頁面</div>
    <div>
      <!-- Title -->
      <label class="form-item d-flex pt-5">
        <h4 class="w-180px">Title</h4>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="career.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- SubTitle -->
      <label class="form-item d-flex pt-5">
        <h4 class="w-180px">SubTitle</h4>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="career.subtitle"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Call To Actiom -->
      <label class="form-item d-flex pt-5">
        <h4 class="w-180px">Call To Aciton</h4>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="career.call_to_action"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- img -->
      <div class="px-5 d-flex py-5">
        <h4 class="w-180px">Background</h4>
        <div class="flex-grow-1 d-flex justify-end">
          <ImgUploader
            :imageUrl.sync="career.background"
            dir="career"></ImgUploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    career: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
  },
};
</script>

<style></style>
